import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Moon, Sun } from "lucide-react";
import { LOGIN_URL, REGISTER_URL } from "../../data/content";

const links = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/bar-gp-calculator", label: "GP calculator" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function currentTheme() {
  const set = document.documentElement.getAttribute("data-theme");
  if (set) return set;
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState("light");
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => setTheme(currentTheme()), []);

  const toggleTheme = () => {
    const next = currentTheme() === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem("barlo-theme", next); } catch (e) { /* storage blocked */ }
    setTheme(next);
  };

  return (
    <header className="nav" data-testid="nav-container">
      <div className="wrap">
        <Link to="/" className="logo" aria-label="Barlo home" data-testid="nav-logo">
          <img className="light-only" src="/brand/barlo-lockup-ink.png" alt="Barlo" width="900" height="233" />
          <img className="dark-only" src="/brand/barlo-lockup-cream.png" alt="Barlo" width="900" height="233" />
        </Link>
        <nav aria-label="Main">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.to.slice(1)}`}
              className={({ isActive }) => (isActive ? "active" : undefined)}
              aria-current={location.pathname === l.to ? "page" : undefined}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="right">
          <a className="signin" href={LOGIN_URL} data-testid="nav-sign-in">Log in</a>
          <button className="theme-btn" type="button" onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"} data-testid="nav-theme-toggle">
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <a className="btn btn-green" href={REGISTER_URL} data-testid="nav-trial-cta">Start free trial</a>
          <button className="theme-btn menu-btn" type="button" aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open} onClick={() => setOpen((v) => !v)} data-testid="nav-mobile-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="mobile-menu">
          <div className="wrap">
            {links.map((l) => <Link key={l.to} to={l.to}>{l.label}</Link>)}
            <Link to="/faq">FAQ</Link>
            <a href={LOGIN_URL}>Log in</a>
            <a className="btn btn-green" href={REGISTER_URL} style={{ marginTop: 8 }}>Start free trial</a>
          </div>
        </div>
      )}
    </header>
  );
}
